var exports = {
  "s8": "PrimerLink__2SYjfE",
  "az": "Box__8gZdPk",
  "m4": "Octicon___8Jgg_",
};

module.exports = exports;
